import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import MuiLoader from "../../components/MuiLoader";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Slide,
  TextField,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

import {
  save_audio_assessment_question,
  update_audio_assessment_question,
  get_audio_assessment_question,
} from "./AudioAssessment.Thunk";

// Toastyfy
import { ToastContainer, toast } from "react-toastify";
import { setSelectedQuestion, updateQuestion } from "./AudioAssessment.Slice";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function CreateQuestion({
  S3,
  S3_BUCKET,
  usertype,
  language,
  program,
  clas,
  subject,
  open,
  onClose,
  assessment,
}) {
  const dispatch = useDispatch();
  const inputFileRef = useRef();
  const [progress, setProgress] = useState("");
  const [question, setQuestion] = useState("");
  const [mark, setMark] = useState("");
  const [filename, setFilename] = useState("");
  const loading = useSelector((state) => state.AudioAssessmentSlice.loading);
  const { selectedQuestion } = useSelector(
    (state) => state.AudioAssessmentSlice
  );
  let questionImage = "";
  const regex = /^[0-9\b]+$/;

  console.log("selectedQuestion", selectedQuestion);

  useEffect(() => {
    if (selectedQuestion) {
      setQuestion(selectedQuestion.question);
      setMark(selectedQuestion.questionWiseMarks);
      setFilename(selectedQuestion.questionImage);
      setPreviewURL(selectedQuestion.questionImage); // Set the previewURL here
    }
  }, [selectedQuestion]);

  // --------------- file actions -------------------
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileType, setSelectedFileType] = useState(null);
  const [selectedFileSize, setSelectedFileSize] = useState(null);
  const [previewURL, setPreviewURL] = useState("");

  const file_on_change = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    setFilename(event.target.files[0].name);
    setSelectedFileType(event.target.files[0].type);
    setSelectedFileSize(event.target.files[0].size);
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreviewURL(reader.result);
    };
    reader.readAsDataURL(file);
  };
  // ------------------------------------------------

  const close_create_question_dialog = () => {
    reset();
    onClose();
  };

  const save_question = async () => {
    if (question == undefined || question == null || question.trim == "")
      toast.error("Question can't be empty");
    else if (!selectedFile) {
      await save_data_into_database();
    } else {
      if (selectedFileSize > 4194304) toast.error("File size exceed");
      else if (
        selectedFileType == "image/png" ||
        selectedFileType == "image/gif" ||
        selectedFileType == "image/jpeg"
      ) {
        await upload_image();
      } else toast.error("Invalid image format");
    }
  };

  const upload_image = async () => {
    //
    const params = {
      ACL: "public-read",
      Bucket: S3_BUCKET,

      Key: "" + new Date().getTime(),
      Body: selectedFile,
      ContentType: "image/jpeg",
    };
    const request = await S3.putObject(params);
    request.on("httpUploadProgress", (evt) => {
      setProgress(Math.round((evt.loaded / evt.total) * 100));
    });
    request.send(async (err, data) => {
      if (err) {
        toast.error("Error uploading file:" + err);
      } else {
        toast.success("File uploaded successfully:");
        const url = `https://${params.Bucket}.S3.${S3.config.region}.amazonaws.com/${params.Key}`;
        questionImage = url;
        await save_data_into_database();
      }
    });
  };

  const save_data_into_database = async () => {
    const body = {
      usertype,
      language,
      program,
      class: clas,
      subject,
      questionId: new Date().getTime().toString(),
      question,
      questionImage,
      questionWiseMarks: parseInt(mark),
    };
    console.log(body, "body");
    await dispatch(save_audio_assessment_question(body));
    await close_create_question_dialog();
  };

  const update_question = async () => {
    if (selectedFileSize > 4194304) {
      toast.error("File size exceeded");
    } else if (selectedFile && isImageFormat(selectedFileType)) {
      await update_image();
    } else {
      await update_data_into_database(selectedQuestion);
      let obj = { usertype, program, clas, subject };
      dispatch(get_audio_assessment_question(obj));
    }
  };

  const isImageFormat = (fileType) => {
    const acceptedFormats = ["image/png", "image/gif", "image/jpeg"];
    return acceptedFormats.includes(fileType);
  };

  const update_image = async () => {
    const params = {
      ACL: "public-read",
      Bucket: S3_BUCKET,
      Key: "" + new Date().getTime(),
      Body: selectedFile,
      ContentType: "image/jpeg",
    };

    const request = await S3.putObject(params);

    request.on("httpUploadProgress", (evt) => {
      setProgress(Math.round((evt.loaded / evt.total) * 100));
    });

    request.send(async (err, data) => {
      if (err) {
        toast.error("Error uploading file: " + err);
      } else {
        toast.success("File uploaded successfully.");

        const url = `https://${params.Bucket}.s3.${S3.config.region}.amazonaws.com/${params.Key}`;
        questionImage = url;

        await update_data_into_database();

        // Update the image preview
        setPreviewURL(url);

        let obj = { usertype, program, clas, subject };
        dispatch(get_audio_assessment_question(obj));
      }
    });
  };

  const delete_file_from_s2 = async (Qid, Qurl, question, image, mark) => {
    delete_file_from_s3(Qid, Qurl, question, mark);
    const body = {
      Qid: Qid,
      Qurl: Qurl,
    };
    dispatch(update_audio_assessment_question(body));
    let obj = { usertype, program, clas, subject };
    dispatch(get_audio_assessment_question(obj));
    // close_create_question_dialog();
  };
  const delete_file_from_s3 = async (Qid, Qurl, mark, question) => {
    // get file name from image url
    const parsedUrl = new URL(Qurl);
    const path = parsedUrl.pathname;
    const segments = path.split("/");
    const filename = segments[segments.length - 1];
    console.log("-->filename: ", filename);

    // delete file from s3
    const params = {
      Bucket: S3_BUCKET,
      Key: filename,
    };
    await S3.deleteObject(params, async (err, data) => {
      if (err) {
        toast.error("Error deleting file:", err);
      } else {
        toast.success("File deleted successfully:", filename);
      }
    });
    const updatedQuestion = {
      question: selectedQuestion.question,
      questionImage: "",
      questionWiseMarks: mark,
    };
    dispatch(setSelectedQuestion(updatedQuestion));
  };

  const update_data_into_database = async (selectedQuestion) => {
    const updatedQuestion = {
      question: selectedQuestion?.question,
      questionWiseMarks: parseInt(selectedQuestion?.mark),
      questionImage: selectedFile
        ? questionImage
        : selectedQuestion.questionImage,
    };

    dispatch(setSelectedQuestion(updatedQuestion));

    const body = {
      questionId: assessment.questionId,
      question,
      questionWiseMarks: parseInt(mark),
      questionImage: selectedFile
        ? questionImage
        : selectedQuestion.questionImage,
    };
    await dispatch(update_audio_assessment_question(body));
    await close_create_question_dialog();
  };

  const reset = () => {
    setQuestion("");
    setPreviewURL("");
    setSelectedFile(null);
    setSelectedFileType(null);
    setSelectedFileSize(null);
    setProgress("");
    setMark("");
  };

  const clearSelectedFile = () => {
    setSelectedFile(null);
    setSelectedFileType(null);
    setSelectedFileSize(null);
  };

  useEffect(() => {}, [filename]);
  // console.log(previewURL, "url");
  return (
    <>
      {selectedQuestion == null ? (
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={close_create_question_dialog}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>Create Audio Assessment Question</DialogTitle>
          <DialogContent>
            {progress > 0 && <div>Upload Progress: {progress}%</div>}
            <div style={{ marginTop: "10px" }}>
              <TextField
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
                id="outlined-multiline-flexible"
                label="Question"
                multiline
                maxRows={4}
                sx={{ height: "100px", width: "100%" }}
              />
            </div>
            <div style={{ marginTop: "0px" }}>
              <TextField
                type="number"
                variant="outlined"
                value={mark}
                onChange={(e) => {
                  if (e.target.value === "" || regex.test(e.target.value)) {
                    setMark(e.target.value);
                  }
                }}
                id="outlined-multiline-flexible"
                label="Mark"
                maxRows={2}
                sx={{ height: "100px", width: "100%" }}
              />
            </div>
            <div
              style={{
                width: "100%",
                height: "200px",
                border: "1px solid gray",
              }}
            >
              {previewURL && (
                <img src={previewURL} alt="Preview" width={300} height={200} />
              )}
            </div>
            <div>
              <input
                type="file"
                accept="image/*"
                onChange={file_on_change}
                ref={inputFileRef}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={close_create_question_dialog}>Cancle</Button>
            <Button onClick={save_question}>Save</Button>
          </DialogActions>
        </Dialog>
      ) : (
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={close_create_question_dialog}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>Update Audio Assessment Question</DialogTitle>
          <DialogContent>
            {progress > 0 && <div>Upload Progress: {progress}%</div>}
            <div style={{ marginTop: "10px" }}>
              <TextField
                value={question}
                onChange={(e) => setQuestion(e?.target?.value)}
                id="outlined-multiline-flexible"
                label="Question"
                multiline
                maxRows={4}
                sx={{ height: "100px", width: "100%" }}
              />
            </div>
            <div style={{ marginTop: "0px" }}>
              <TextField
                type="number"
                variant="outlined"
                value={mark}
                onChange={(e) => {
                  if (e.target.value === "" || regex.test(e.target.value)) {
                    setMark(e.target.value);
                  }
                }}
                id="outlined-multiline-flexible"
                label="Mark"
                maxRows={2}
                sx={{ height: "100px", width: "100%" }}
              />
            </div>
            <div
              style={{
                width: "100%",
                height: "200px",
                border: "1px solid gray",
              }}
            >
              {previewURL || selectedQuestion?.questionImage ? (
                <div style={{ position: "relative", marginBottom: "10px" }}>
                  <img
                    src={previewURL || selectedQuestion?.questionImage}
                    alt="Preview"
                    width={300}
                    height={200}
                  />
                  <IconButton
                    aria-label="Delete Image"
                    style={{
                      position: "absolute",
                      top: "-8px",
                      right: "-8px",
                      color: "red",
                    }}
                    // onClick={update_image}
                  >
                    <DeleteIcon
                      onClick={() =>
                        delete_file_from_s2(
                          selectedQuestion?.questionId,
                          selectedQuestion?.questionImage,
                          selectedQuestion?.questionWiseMarks,
                          selectedQuestion?.question
                        )
                      }
                    />
                  </IconButton>
                  {/* {filename ? <label>{filename}</label> : null} */}
                </div>
              ) : (
                <div>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={file_on_change}
                    ref={inputFileRef}
                  />
                  {selectedFile && (
                    <IconButton
                      aria-label="Delete Image"
                      style={{
                        position: "absolute",
                        top: "8px",
                        right: "8px",
                        color: "red",
                      }}
                      onClick={clearSelectedFile}
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </div>
              )}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={close_create_question_dialog}>Cancle</Button>
            <Button onClick={update_question}>Update</Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Toaster */}
      <ToastContainer />

      {/* Loader */}
      <MuiLoader open={loading} />
    </>
  );
}
